import BoardTab from './tab'
import { register } from '~/mixins/pluggable.js'

register('board', BoardTab)
